import { Control, FieldErrors, UseFormClearErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { useAppBanner } from './banners/hooks/use-app-banner';

export enum BannerType {
  TWILIO_ERROR = 'TWILIO_ERROR',
  SWITCH_CALL = 'SWITCH_CALL',
  RATE_LIMIT = 'RATE_LIMIT',
  SUSPENSION_WARNING = 'SUSPENSION_WARNING',
  INSUFFICIENT_BALANCE_SUSPENDED = 'INSUFFICIENT_BALANCE_SUSPENDED',
  ACCOUNT_SUSPENDED = 'ACCOUNT_SUSPENDED',
  CALL_NOT_SUPPORTED = 'CALL_NOT_SUPPORTED',
  NON_RENEWING = 'NON_RENEWING',
  MIC_PERMISSION = 'MIC_PERMISSION',
  SCHEDULED_DOWNGRADE = 'SCHEDULED_DOWNGRADE',
  WALLET_LOW = 'WALLET_LOW',
  // WALLET_MEDIUM_LOW = 'WALLET_MEDIUM_LOW',
  NOTIFICATION_SILENT = 'NOTIFICATION_SILENT',
  MFA_SETUP_REMINDER = 'MFA_SETUP_REMINDER',
  PREFERRED_CONTACT = 'PREFERRED_CONTACT',
}

export type BannerResolverType = ReturnType<typeof useAppBanner>;

export type MicPermissionType = {
  open: boolean;
  onClose: VoidFunction;
};

export type UseScheduledDowngradeOptions = {
  workspaceSubscriptionId?: string | null;
};

export type PreferredContactMethodType = {
  open: boolean;
  onClose: VoidFunction;
  control: Control<TPreferredContactForm>;
  selectedMethods: {
    email: boolean;
    messaging: boolean;
    phoneCall: boolean;
  };
  setValue: UseFormSetValue<TPreferredContactForm>;
  trigger: UseFormTrigger<TPreferredContactForm>;
  onSubmit: VoidFunction;
  clearErrors: UseFormClearErrors<TPreferredContactForm>;
  errors: FieldErrors<TPreferredContactForm>;
};

export type TPreferredContactForm = {
  email: string;
  messaging: string;
  messagingType: string;
  phoneCall: string;
  timeRange: [string, string];
  emailEnabled: boolean;
  messagingEnabled: boolean;
  phoneCallEnabled: boolean;
  contactMethods?: boolean;
};
